import { computed, unref, type MaybeRef } from "vue";
import { createQuery } from "@/queries";
import { searchHistory } from "@/features/search/api/search";
import type { SearchHistoryResponce } from "@/types/searchItemsTypes";

export interface SearchHistoryQueryInput {
  size: number;
  type: string;
}

export const useSearchHistoryQuery = (
  input: MaybeRef<SearchHistoryQueryInput | null | undefined>,
  enabled?: MaybeRef<boolean | undefined>,
) => {
  return createQuery<SearchHistoryResponce>({
    key: computed(() => {
      const value = unref(input);
      if (!value) return null;
      return ["search", "history", value.type, value.size];
    }),
    fetcher: async () => {
      const value = unref(input);
      if (!value) {
        throw new Error("history params are required");
      }
      const response = await searchHistory(value.size, value.type);
      return response.data;
    },
    enabled: computed(() => {
      const value = unref(input);
      const baseEnabled = enabled === undefined ? true : Boolean(unref(enabled));
      return baseEnabled && Boolean(value);
    }),
    staleTime: 60 * 1000,
  });
};

